var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex wizard-loader",class:`step-${_vm.step}`},[_c('div',{staticClass:"progress-line",style:({ width: _vm.progress + '%' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }